import _ from 'lodash';

import * as actions from '../actions/DataValueLookupActions';

const initialState = {};

export const getLookupValuesKey = (tableName, fieldName) => `${tableName}.${fieldName}`;

function DataValueLookupReducer(state = initialState, action) {
  switch (action.type) {
    case actions.GET_LOOKUP_VALUES_FAILURE: {
      const { payload } = action;
      const oldValue = _.get(state, payload.key, {});
      const value = {
        ...oldValue,
        error: payload.error,
        fetching: false,
      };

      const newState = _.cloneDeep(state);
      _.set(newState, payload.key, value);

      return newState;
    }
    default:
      return state;
  }
}

export default DataValueLookupReducer;
